/**
 * @generated SignedSource<<fc519ee704e35bcce498b5be8fe2129f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommentsPanelResolveThreadMutation$variables = {
  id: string;
};
export type CommentsPanelResolveThreadMutation$data = {
  readonly Comment_ResolveThread: {
    readonly thread: {
      readonly id: string;
      readonly resolvedBy: {
        readonly id: string;
      } | null;
    };
  } | null;
};
export type CommentsPanelResolveThreadMutation = {
  response: CommentsPanelResolveThreadMutation$data;
  variables: CommentsPanelResolveThreadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "threadId",
        "variableName": "id"
      }
    ],
    "concreteType": "ResolveThread",
    "kind": "LinkedField",
    "name": "Comment_ResolveThread",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CommentThread",
        "kind": "LinkedField",
        "name": "thread",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "resolvedBy",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsPanelResolveThreadMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentsPanelResolveThreadMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9a7aa723eae4d1b4c9fa3a2470053186",
    "id": null,
    "metadata": {},
    "name": "CommentsPanelResolveThreadMutation",
    "operationKind": "mutation",
    "text": "mutation CommentsPanelResolveThreadMutation(\n  $id: ID!\n) {\n  Comment_ResolveThread(threadId: $id) {\n    thread {\n      id\n      resolvedBy {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "598bf8d39b0469f7e92b317707fdc468";

export default node;
